import { render, staticRenderFns } from "./operate-role-modal.vue?vue&type=template&id=414bfac4&scoped=true"
import script from "./operate-role-modal.vue?vue&type=script&lang=js"
export * from "./operate-role-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "414bfac4",
  null
  
)

export default component.exports